import type { LoadersType } from '../types/loaders'

export const loadersInitialValues: LoadersType = {
  // Loaders that get triggered automatically should be defaulted to true,
  // while loaders that get triggered by user interaction should be defaulted to false
  isLoadingShippingMethods: true,
  isLoadingSavedAddresses: true,
  isLoadingSavedCreditCards: true,
  isLoadingStoreCredit: false,
  isLoadingSubmitOrder: false,
  isLoadingSigningOut: false,
  isLoadingOrderCalculationSideCart: false,
}
